import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="font-['Lato'] bg-background-50 text-foreground-900 min-h-screen">
      {/* Header */}
      <header className="bg-foreground-950 text-white py-4 px-6 md:px-12">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link
            to="/"
            className="font-['Playfair_Display'] text-lg font-semibold text-white hover:text-accent-300 transition-colors"
          >
            JOINT GENESIS
          </Link>
          <Link
            to="/"
            className="text-white/60 text-sm hover:text-white transition-colors flex items-center gap-1"
          >
            <i className="ri-arrow-left-line" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p className="font-['Playfair_Display'] text-accent-600 text-sm tracking-[0.25em] uppercase mb-4">
          Legal Information
        </p>
        <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-10">
          Privacy Policy
        </h1>
        <div className="w-16 h-px bg-accent-400 mb-12" />

        <div className="space-y-8 text-foreground-700 text-base leading-relaxed">
          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              1. Introduction
            </h2>
            <p>
              Joint Genesis Editorial respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website. By using our website, you consent to the practices described in this policy.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              2. Information We Collect
            </h2>
            <p className="mb-3">
              We may collect the following types of information:
            </p>
            <ul className="space-y-2 text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 shrink-0" />
                <span><strong className="text-foreground-900">Personal Information:</strong> Name, email address, and other contact details you voluntarily provide when subscribing to our newsletter, downloading resources, or contacting us.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 shrink-0" />
                <span><strong className="text-foreground-900">Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent on pages, links clicked, and other diagnostic data.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 shrink-0" />
                <span><strong className="text-foreground-900">Device Information:</strong> Browser type, IP address, device type, operating system, and other technical identifiers.</span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              3. How We Use Your Information
            </h2>
            <p className="mb-3">
              We use the information we collect for the following purposes:
            </p>
            <ul className="space-y-2 text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>To provide, maintain, and improve our website and services</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>To send you newsletters, updates, and promotional materials (with your consent)</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>To respond to your inquiries and provide customer support</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>To analyze usage patterns and improve user experience</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>To detect, prevent, and address technical issues or security threats</span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              4. Cookies and Tracking Technologies
            </h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our website and store certain information. Cookies are files with a small amount of data that may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, some portions of our website may not function properly.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              5. Third-Party Services
            </h2>
            <p>
              Our website may contain links to third-party websites or services that are not owned or controlled by Joint Genesis Editorial. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. We strongly advise you to review the privacy policy of every site you visit.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              6. Data Security
            </h2>
            <p>
              We take reasonable precautions to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              7. Your Rights
            </h2>
            <p className="mb-3">
              Depending on your location, you may have the following rights regarding your personal information:
            </p>
            <ul className="space-y-2 text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>The right to access and receive a copy of your personal data</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>The right to rectify or update inaccurate information</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>The right to request deletion of your personal data</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>The right to withdraw consent for marketing communications</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-accent-500 mt-0.5 shrink-0" />
                <span>The right to object to certain types of data processing</span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              8. Children's Privacy
            </h2>
            <p>
              Our website is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately so we can take appropriate action.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              9. Changes to This Policy
            </h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date. We encourage you to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              10. Contact Us
            </h2>
            <p>
              If you have any questions or concerns about this Privacy Policy or our data practices, please contact us through the channels provided on our website.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-background-200">
          <p className="text-foreground-400 text-sm text-center">
            Last updated: July 2026
          </p>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-foreground-950 text-white/50 py-8 px-6">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <span className="font-['Playfair_Display'] text-white font-semibold">
            JOINT GENESIS
          </span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms of Use
            </Link>
          </div>
          <span>&copy; 2026 All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}